<template>
  <div style="padding-top: 12px;width:1228px;" align="center">
    <div class="mb-10">
      <img :src="introImage1" usemap="#map" name="appMain" class="mb-10" />
    </div>
    <div
      class="video-container mb-0 mt-10"
      style="TEXT-ALIGN: center"
      align="center"
    >
      <object
        type="text/html"
        width="950"
        height="600"
        data="//player.vimeo.com/video/420987404?autoplay=1&mute=1&rel=0&controls=0&showinfo=0&loop=1&start=4&playlist=fJ78Fv7uoOI"
        allowfullscreen
      ></object>
    </div>
    <div class="mb-10 mt-10">
      <img :src="introImage2" usemap="#map" name="appMain" class="mb-10" />
    </div>
    <div
      class="video-container mb-10 mt-10"
      style="TEXT-ALIGN: center"
      align="center"
    >
      <object
        type="text/html"
        width="950"
        height="600"
        data="//player.vimeo.com/video/422716930?autoplay=1&mute=1&rel=0&controls=0&showinfo=0&loop=1&start=4&playlist=fJ78Fv7uoOI"
        allowfullscreen
      ></object>
    </div>
    <div class="mt-10">
      <img :src="introImage3" usemap="#map" name="appMain" class="mt-10" />
    </div>
    <map name="map">
      <area
        shape="rect"
        coords="416, 506, 778, 563"
        v-bind:href="`/authservice/${$store.state.mallId}/serviceIntro`"
        target="_blank"
      />
      <area
        shape="rect"
        coords="423, 1473, 787, 1532"
        v-bind:href="`/authservice/${$store.state.mallId}/serviceIntro`"
        target="_blank"
      />
    </map>
    <MallManagerInfo ref="MallManagerInfo"></MallManagerInfo>
  </div>
</template>

<script>
import M from "@/libs/mapping.js";
import MallManagerInfo from "@/components/authservice/service/modal/MallManagerInfo.vue";
import CommonMixin from "@/mixins/CommonMixin.js";

export default {
  data: () => ({
    M,
    introImage1: require("../../assets/authservice/images/app_new_main_1.jpg"),
    introImage2: require("../../assets/authservice/images/app_new_main_2.jpg"),
    introImage3: require("../../assets/authservice/images/app_new_main_3.jpg"),
    ordersPayload: {
      mall_name: null,
      mall_manager: null,
      mall_phone: null,
      mall_email: null,
    },
  }),
  methods: {
    moveIntro: function() {
      let route = this.$router.resolve({
        path: `/authservice/${this.$store.state.mallId}/serviceIntro`,
      });
      window.open(route.href, "_blank");
    },
    getPaymentInfo: async function() {
      try {
        let data = await M.api(M.entry("/api/orders/latest"), {});
        if (data) {
          this.ordersPayload.mall_name = data.mall_name;
          this.ordersPayload.mall_manager = data.mall_manager;
          this.ordersPayload.mall_phone = data.mall_phone;
          this.ordersPayload.mall_email = data.mall_email;
        }
      } catch {
        this.ordersPayload.mall_name = "";
        this.ordersPayload.mall_manager = "";
        this.ordersPayload.mall_phone = "";
        this.ordersPayload.mall_email = "";
      }
    },
  },
  mixins: [CommonMixin],
  created: async function() {
    await this.getPaymentInfo();
    if (!this.ordersPayload.mall_phone) {
      this.$refs.MallManagerInfo.show(this.ordersPayload);
    }
  },
  mounted: function() {},
  components: {
    MallManagerInfo,
  },
};
</script>
